






























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TransStatement, BetHistoryEntity } from '@/common/api/model';
import Api from '@/common/api';

import * as PleasedModel from '@/common/api/models.pleased';
import { TransactionType } from '@/common/config';
import Input from '@/components/Input.vue';
import { Button, BottomWrapper } from '../BottomWrapper.vue';
import LoginGuest from './LoginGuest.vue';
import GuestForm from './GuestForm.vue';
import Transaction from './Transaction/Transaction.vue';
import BetTransaction from './Transaction/BetTransaction.vue';
import LoggedInForm from './LoggedInForm.vue';
import ContactOptions from './ContactOptions.vue';
import { namespace } from 'vuex-class';
import { emitOpenMyRequest } from '@/common/eventBus';
import waiting from '@/components/loading/waiting';
import { listenFromParent } from '@/common/bridge';
import { analytics } from '@/common/gaHelper';
import { FormField, ConnectRequestEvent, TransactionInputEvent, VisitorInformation, VisitorInfoFilled, DynamicFieldData } from '@/common/types';

const userModule = namespace('user');

export enum StepRoute {
  EndChat, // help_Chat-10
  LoginGuest, // help_Chat-6
  GuestForm, // help_Chat-open ticket without login
  // Login, // help_Chat-7
  Transaction, // help_Chat-8
  LoggedInForm, // help_Chat-8a
  ContactOptions, // help_Chat-9
  OpenRequestEnd
}

export interface StepChangeEvent {
  step: StepRoute,
  previous: StepRoute
}

interface SavedDataToPass {
  transactions: TransactionInputEvent | null
  guest: VisitorInfoFilled | null
  loggedInForm: VisitorInfoFilled | null
}

enum buttonKeyMap {
  Yes = 'yes',
  No = 'no',
  End = 'end',
  // Login = 'login'
};

const buttonMaker = (name: string, id = name): Button => ({ name, id, isActive: true });

@Component({
  components: {
    BottomWrapper,
    Input,
    LoginGuest,
    GuestForm,
    // Login,
    Transaction,
    LoggedInForm,
    ContactOptions,
    BetTransaction,
  },
  directives: {
    waiting,
  },
})
export default class RuleENgineHelper extends Vue {
  @Prop() readonly actionableItemKey!: number;
  @Prop() readonly showLoggedInOptions!: { showCall: boolean, showLiveChat: boolean, showOpenRequest: boolean };
  @Prop({ default: false }) readonly isGuestAllowed!: boolean;
  @Prop({ default: '' }) readonly issueMsg!: '';
  @Prop({ default: '' }) readonly ticketSubject!: string;
  @Prop(Boolean) readonly fromActiveConversation!: boolean;
  @Prop() readonly userSelections!: {message: string; timestamp: string}[]

  @userModule.State('isLogin') isLogin!: boolean;

  @userModule.Mutation('updateLoginStatus') updateLoginStatus!: Function;

  StepRoute = StepRoute;
  get buttonMap (): {[index: number]: Button[]} {
    return {
      [StepRoute.EndChat]: [buttonMaker(this.$t('global.end_chat') as string)],
      // [StepRoute.LoginGuest]: [],
      [StepRoute.OpenRequestEnd]: [buttonMaker(this.$t('global.end_chat') as string, buttonKeyMap.End)] };
  };
  actionMap = {
    [StepRoute.EndChat]: this.endChat,
    // [StepRoute.LoginGuest]: this.handleLoginGuest,
    [StepRoute.GuestForm]: () => {},
    [StepRoute.Transaction]: () => {},
    [StepRoute.OpenRequestEnd]: this.handleLoggedInRequestEnd,
  }
  currentStep: StepRoute | null = null;
  prevStep: StepRoute | null = null;

  savedDataToPass: SavedDataToPass = {
    transactions: null,
    guest: null,
    loggedInForm: null,
  }

  loading = false;
  // Transactions
  actionType: TransactionType | null = null;
  transactions: TransStatement[] | BetHistoryEntity[] = [];
  fieldData: DynamicFieldData | null = null;
  guestDescription = '';
  requestInfo: { subject: string, description: string, email: string } = { subject: '', description: '', email: '' }

  get staticFormFields (): FormField[] {
    return [
      {
        id: -10000,
        displayName: 'Description',
        placeholder: 'Describe your problem',
        name: 'description',
        required: true,
      }, {
        id: -10001,
        displayName: 'Subject',
        placeholder: 'Subject',
        name: 'subject',
        required: false,
      },
    ];
  }

  apiFormFields: FormField[] = [];

  get bottomWrapperHandler () {
    const { actionMap, currentStep } = this;
    return actionMap[currentStep as keyof typeof actionMap] || (() => {});
  }

  get allFormFields (): FormField[] {
    return [...this.staticFormFields, ...this.apiFormFields];
  }

  get extraTicketFields (): PleasedModel.TicketField[] {
    return this.fieldData && this.fieldData.fields ? this.fieldData.fields.filter(f => f.id > 0).map(f => ({ fieldId: f.id, fieldValue: f.value })) : [];
  }

  created () {
    this.actionType = this.actionableItemKey === 1 ? TransactionType.Deposit
      : this.actionableItemKey === 2 ? TransactionType.Withdrawal
        : this.actionableItemKey === 3 ? TransactionType.Bet : null;

    // Only NOT resolved will go to RuleEnginHelper
    if (this.isLogin) {
      this.resolveTransactionStep();
    } else {
      if (!this.isLogin) {
        listenFromParent('LOGIN_POP', (data: { isLogin: boolean, token: string }) => {
          if (this.currentStep === StepRoute['LoginGuest']) {
            this.updateLoginStatus(data);

            this.handleLogin();
          }
        });
        this.currentStep = StepRoute['LoginGuest'];
      } else {
        if (!this.actionType) {
          this.currentStep = StepRoute['LoggedInForm'];
          return;
        }
        this.currentStep = StepRoute['Transaction'];
      }
    }
    // TODO: [voice dev]
    // this.currentStep = StepRoute['ContactOptions'];
  }

  resolveTransactionStep () {
    if (this.fromActiveConversation) {
      this.currentStep = StepRoute.ContactOptions;
      return;
    }
    if (this.actionType === TransactionType['Deposit'] || this.actionType === TransactionType['Withdrawal']) {
      this.loading = true;
      Api.getTransactionHistory({
        type: this.actionType,
        pageSize: 5,
        _t: +new Date(),
      }).then(res => {
        if (res.bizCode === 10000) {
          this.transactions = res.data.statements;
          this.currentStep = StepRoute['Transaction'];
        }
      }).finally(() => {
        this.loading = false;
      });
    } else if (this.actionType === TransactionType['Bet']) {
      this.loading = true;
      Api.getBetHistory({
        isSettled: 10,
        pageSize: 5,
        _t: +new Date(),
      }).then(res => {
        if (res.bizCode === 10000) {
          this.transactions = res.data.entityList;
          this.currentStep = StepRoute['Transaction'];
        }
      }).finally(() => {
        this.loading = false;
      });
      this.currentStep = StepRoute['Transaction'];
    } else {
      this.currentStep = StepRoute['LoggedInForm'];
    }
  }

  @Watch('currentStep')
  onStepChange (step: StepRoute, previous: StepRoute) {
    this.prevStep = previous;
    this.$emit('step:changed', { step, previous } as StepChangeEvent);
  }

  updated () {
    this.$emit('updated');
  }

  /**
   * @event GuestForm#submit:detail
   */
  onSubmitGuestForm ($event: VisitorInfoFilled) {
    const { visitorInfo, description } = $event;
    this.guestDescription = description;

    this.requestInfo.subject = this.ticketSubject;
    this.requestInfo.description = description;
    this.requestInfo.email = visitorInfo.email;

    this.savedDataToPass.guest = $event;

    this.$emit('visitor:info', $event);
    this.currentStep = StepRoute['ContactOptions'];
  }

  /**
   * @event ContactOption#connect:request
   */
  handleContactOption ($event: ConnectRequestEvent) {
    this.$emit('connect:request', $event);
    if ($event.type === 'openRequest') {
      this.currentStep = StepRoute['OpenRequestEnd'];
    }
  }

  handleBackLogin () {
    this.currentStep = StepRoute['Transaction'];
  }

  handleBackContactOptions () {
    this.currentStep = this.prevStep;
  }

  endChat () {
    this.$emit('endChat');
  }

  // Login
  handleLogin () {
    this.$emit('login:successful');
    this.resolveTransactionStep();
  }

  handleTransactionInput ($event: TransactionInputEvent) {
    this.savedDataToPass.transactions = $event;
    this.$emit('transaction:input', $event);
    this.currentStep = StepRoute['LoggedInForm'];
  }

  // LoggedInForm
  handleLoggedInform (data: VisitorInfoFilled & DynamicFieldData) {
    const { visitorInfo, description = '', fields } = data;

    this.fieldData = { fields };
    this.requestInfo.subject = this.ticketSubject;
    this.requestInfo.description = description;
    this.requestInfo.email = visitorInfo.email;

    this.savedDataToPass.loggedInForm = { visitorInfo, description };

    this.$emit('visitor:info', { visitorInfo, description });
    this.currentStep = StepRoute['ContactOptions'];
  }

  handleLoggedInRequestEnd (button: Button) {
    console.log('clicked', { button });
    if (button.id === buttonKeyMap.End) {
      this.endChat();
    } else {
      emitOpenMyRequest(true);
    }
  }
}
